import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import config from 'config';
import features from 'lib/common/features';
import collectSeats from 'lib/seatmaps/collectSeats';
import collectZonesByLevel from 'lib/seatmaps/collectZonesByLevel';
import panZoom from 'behaviours/panZoom';
import animateMap from 'behaviours/animateMap';
import enhanceSeats from 'behaviours/enhanceSeats';
import changeScreen from 'behaviours/changeScreen';
import { map, mapValues } from 'lodash';
import mediator, { ACTIONS } from '../mediator';

import BackButton from 'components/BackButton';
import SeatMap from 'components/SeatMap';
import LoadingSpinner from 'components/LoadingSpinner';
import ZoomControls from 'components/ZoomControls';

const SeatMapContainer = React.createClass({
  propTypes: {
    hasGeneratedSvg: PropTypes.bool,
    svgData: PropTypes.string.isRequired,
    seatData: PropTypes.arrayOf(PropTypes.object),
    facility: PropTypes.object,
    isEnhanced: PropTypes.bool,
    selectedLevel: PropTypes.object,
    seatMapReady: PropTypes.bool,
    onPanZoomInit: PropTypes.func,
    onSeatMapReady: PropTypes.func,
    prices: PropTypes.array
  },
  getInitialState: function() {
    return {
      panZoomInstance: null,
      availability: null,
      seats: null,
      loading: true
    };
  },
  componentDidMount: function() {
    let { svgEl, levelEls } = this._seatMapRefs;

    if (!this.props.hasGeneratedSvg && levelEls.length) {
      animateMap(svgEl, levelEls);

      if (this.props.selectedLevel) {
        mediator.publish(
          ACTIONS.LEVEL_SELECTED,
          this.props.selectedLevel.selector
        );
      }
    }

    this.setState({ loading: true });
    let zoomControlsOptions = features.getOption('panZoom', 'options');
    if (svgEl && zoomControlsOptions) {
      let panZoomInstance = panZoom(svgEl, zoomControlsOptions);
      this.setState({ panZoomInstance: panZoomInstance });
      this.props.onPanZoomInit(panZoomInstance);
    }
  },
  componentDidUpdate: function() {
    var shouldRenderSeatMap =
      !this.props.isEnhanced &&
      this.props.seatData.length &&
      this._seatMapRefs.seatEls.length &&
      !this.isProcessingData &&
      this.props.prices.length;

    if (shouldRenderSeatMap) {
      this.isProcessingData = true;

      collectSeats(
        this._seatMapRefs.seatEls,
        this.props.seatData
      ).then(collectedSeats => {
        collectedSeats = enhanceSeats(collectedSeats, this.props.prices);
        changeScreen(this._seatMapRefs.svgEl);

        var zonesByLevel = collectZonesByLevel(collectedSeats);

        this.props.onSeatMapReady(
          collectedSeats,
          zonesByLevel,
          this.collectLevelDetails(this._seatMapRefs.levelEls)
        );

        this.isProcessingData = false;

        this.setState({
          seats: collectedSeats,
          loading: false
        });
      });
    }

    const facility = this.props.facility;

    if (
      !this.state.availability &&
      this.state.seats &&
      facility &&
      'levels' in facility
    ) {
      let levels = facility.levels;

      let availableSeats = this.state.seats.filter(seat => {
        return parseInt(seat.data.seat_status.id, 10) === 0;
      });

      levels = mapValues(levels, screens => {
        return screens.reduce((carry, screen) => {
          const screenSeats = availableSeats.filter(seat => {
            return parseInt(seat.data.screen_no, 10) === screen;
          });

          return carry + screenSeats.length;
        }, 0);
      });

      this.setState({
        availability: levels
      });
    }
  },
  collectLevelDetails: function(levelEls) {
    if (levelEls.length) {
      return map(levelEls, function(el) {
        return {
          el: el,
          isAvailable:
            el.querySelectorAll('.seat:not(.seat--killed)').length > 0,
          label: el.getAttribute('data-name') || el.id
        };
      });
    }
  },
  visibilityStyles: function() {
    let styles = { visibility: 'hidden' };
    return !this.props.seatMapReady ? styles : null;
  },
  render: function() {
    let availability = this.state.availability;

    if (availability) {
      availability = mapValues(availability, (count, level) => {
        const plural = count === 1 ? 'seat' : 'seats';

        return `${level} ${count} ${plural} available`;
      });
    }

    return (
      <div
        className={classnames({
          'syos-seatmap-container': true,
          'has-graphic-seatmap':
            this.props.isEnhanced && !this.props.hasGeneratedSvg,
          'has-back-button':
            features.isEnabled('backButton') && config.redirectUrl !== undefined
        })}
        style={this.visibilityStyles()}
      >
        <LoadingSpinner isActive={this.state.loading} />

        {features.isEnabled('backButton') && config.redirectUrl ? (
          <BackButton returnUrl={config.redirectUrl} />
        ) : null}

        {features.isEnabled('panZoom') && this.state.panZoomInstance ? (
          <ZoomControls panZoomInstance={this.state.panZoomInstance} />
        ) : null}

        <SeatMap
          svgData={this.props.svgData}
          facility={this.props.facility}
          isEnhanced={this.props.isEnhanced}
          availability={availability}
          ref={component => {
            this._seatMapRefs = component && {
              el: component._seatmap,
              svgEl: component._seatmapSvg,
              seatEls: component._seats,
              levelEls: component._levels
            };
          }}
        />
      </div>
    );
  }
});

export default SeatMapContainer;



// WEBPACK FOOTER //
// ./src/javascripts/app/containers/SeatMapContainer.js